/*-----------------------------------------------------------------
- Product Card
-----------------------------------------------------------------*/
export default {
    percent_mark: '٪',
    add_to_cart : 'افزودن به سبد',
    toman       : 'تومان',
    rate_count  : '{count} نظر',
    empty_rate  : 'نظری ثبت نشده است',
    out_of_stock: 'ناموجود',
    discount    : 'تخفیف',
    see_product : 'مشاهده محصول',
    new_product : 'جدید',
};
